"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _index = _interopRequireDefault(require("./reducers/index"));

var _epics = _interopRequireDefault(require("./epics"));

var _Routes = _interopRequireDefault(require("./Routes"));

var _UrlPathParams = require("settings-ui-sdk/constants/UrlPathParams");

var _default = {
  route: _UrlPathParams.CONTENT_MEMBERSHIP,
  reducer: _index.default,
  routes: _Routes.default,
  rootEpic: _epics.default,
  shouldModuleRender: function shouldModuleRender(_ref) {
    var gates = _ref.gates,
        scopes = _ref.scopes;
    // Render the module if
    return (// has the marketing restricted content scope
      scopes.includes('marketing-content-restricted-write') || // has the service restricted content scope and is ungated
      scopes.includes('service-content-restricted-write') && gates.includes('KnowledgeContent:RestrictedContent')
    );
  }
};
exports.default = _default;
module.exports = exports.default;